<template>
	<section class="mask-shade row align-center space-center">
		<div class="shade-box">
			<div class="row space-between align-center shade-title">
				<div class="row align-center">
					<i></i>
					<span>设置历练公单业绩分配</span>
				</div>
				<span v-if="1===2" class="el-icon-close" @click="closeMask"></span>
			</div>
      <div class="shade-body">
        <div class="shade-remark">
          <div>历练公单业绩分配逻辑：</div>
          <div>历练公单业绩不分配培训本人，可选择平均分配培训店铺在编人员。</div>
          <div>最终历练业绩归属培训店铺。</div>
          <p>注：当前历练公单为业绩分配状态，若历练业绩不分配则联系商学院专员或区域运营。</p>
        </div>
        <div class="select-item">
          <span>历练人员(无业绩)：</span>
          <el-select placeholder="请选择历练公单历练人员" size="small" v-model="selectId" style="width: 100%;">
            <el-option v-for="item in listOtherStore" :key="item.id" :label="item.realName" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>业绩分配给：</span>
          <el-select multiple placeholder="请选择历练公单业绩分配人员" size="small" v-model="selectUserIds" style="width: 100%;">
            <el-option v-for="item in publicList" :key="item.id" :label="item.realName" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="user-count" v-if="selectUserIds.length">共{{selectUserIds.length}}人分配该单据业绩</div>
        <div class="shade-btn">
          <el-button v-if="1===2" @click="closeMask">取消</el-button>
          <el-button type="primary" style="width: 100px;height: 38px;font-size: 16px;" @click="sureHandel">确 定</el-button>
        </div>
      </div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'PublicExperience',
	props: {
    shopList: {
      type: Array,
      default: () => []
    },
    publicList: {
      type: Array,
      default: () => []
    },
    experienceList: {
      type: Array,
      default: () => []
    },
    temperingUserId: {
      type: String,
      default: () => ''
    }
	},
	data(){
		return{
      selectId: '',
      selectUserIds: [],
      listOtherStore: []
		}
	},
	created() {
    this.selectId = this.temperingUserId
    this.selectUserIds = this.experienceList
    this.listOtherStore = this.shopList.filter(item=>{
      return item.isCashierAllowed === 'Y' && item.userType !== 'store'
    })
	},
	methods: {
		closeMask(){
			this.$emit('close')
		},
    uniqueObjArray(arr, key){
      if(!Array.isArray(arr) || arr.length === 0 || !key) return arr
      const map = new Map()
      arr.forEach(item => {
        const uniqueKey = item[key]
        if(uniqueKey && !map.has(uniqueKey)){
          map.set(uniqueKey, item)
        }
      })
      return Array.from(map.values())
    },
		sureHandel(){
      if(!this.selectId){
        return this.$message({ type: 'error', message: '请选择历练公单历练人员', duration: 2000, showClose: true })
      }
			if(!this.selectUserIds.length){
				return this.$message({ type: 'error', message: '请选择历练公单分配人员', duration: 2000, showClose: true })
			}
      this.$emit('close', this.selectUserIds, this.selectId)
		}
	}
}
</script>

<style lang="scss" scoped>
.mask-shade{
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	.shade-box{
		width: 580px;
    background: #fff;
    .shade-title{
      background: rgb(245,247,250);
      padding: 10px;
      border-radius: 4px 4px 0 0;
      i{
        width: 4px;
        height: 20px;
        background: rgb(7,124,242);
        margin-right: 10px;
        float: left;
        margin-top: 1px;
      }
      >span{
        color: #666;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .shade-body{
      padding: 10px;
      font-size: 14px;
      .shade-remark{
        padding: 10px;
        margin-bottom: 10px;
        background: rgb(244,246,249);
        div{
          line-height: 30px;
        }
        p{
          color: red;
          margin-top: 10px;
        }
      }
      .select-item{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span{
          width: 130px;
          flex-shrink: 0;
          text-align: right;
        }
      }
      .user-count{
        color: #067cf2;
        //text-align: right;
        //margin-top: -15px;
      }
      .shade-btn{
        display: flex;
        justify-content: center;
        margin: 30px 0 30px;
      }
    }
	}
}
</style>